/**
 * THE ACTIVE FILTERS AS CHIPS — one component, three homes since 0.1.456: the desk Display
 * bar (beside the Sort chip, the frame's "+ Filter" spot), the desk panel's Filters section,
 * and the phone Display sheet's Filters row (frame 57). Each chip names its DIMENSION and its
 * value ("Source: Zalando") so it says what it does, and the WHOLE chip is the remove button
 * — maintainer, 3 Sep 2026: "if I just simply click on the chip, it should also just unselect
 * the filter", with a ✕ that shows on hover on the desk and always on the phone (CSS).
 *
 * Until 0.1.456 the desk bar showed "+ Filter (1)" — a count with no way to see or clear
 * what was on without opening the sheet — and the items screen carried its own chip markup
 * (`filterChipsEl`), the third copy of the shape: extracted here on that third occurrence.
 */
export interface FilterChip {
  key: string;
  /** The dimension's word ("Source", "Status"); empty for a chip that is its own sentence. */
  dim: string;
  label: string;
  onRemove: () => void;
}

export function FilterChips({
  chips,
  onAdd,
  addLabel = '+ Filter',
}: {
  chips: FilterChip[];
  onAdd: () => void;
  /** "+ Filter" everywhere since 0.1.526 (the "Add" dropped from every add door; it read "+ Add
   *  filter" in the panel and the sheet, frames 2/57). */
  addLabel?: string;
}): JSX.Element {
  return (
    <div className="display-chips">
      {chips.map((c) => (
        <button
          key={c.key}
          type="button"
          className="display-chip-on"
          aria-label={`Remove filter ${c.dim === '' ? '' : `${c.dim}: `}${c.label}`}
          onClick={c.onRemove}
        >
          {c.dim !== '' && <span className="display-chip-dim">{c.dim}:</span>}
          <span>{c.label}</span>
          <span className="display-chip-x" aria-hidden="true">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 3 L9 9 M9 3 L3 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </span>
        </button>
      ))}
      <button type="button" className="linklike display-add" onClick={onAdd}>
        {addLabel}
      </button>
    </div>
  );
}
